// uploads.js

export const types = {
  LOADING: 'UPLOADS.LOADING',
  READY: 'UPLOADS.READY',
  FETCHING_TEMPLATE_METADATA: 'UPLOADS.FETCHING_TEMPLATE_METADATA',
  FETCHED_TEMPLATE_METADATA: 'UPLOADS.FETCHED_TEMPLATE_METADATA',
  FETCHING_TEMPLATE_METADATA_FAILED:
    'UPLOADS.FETCHING_TEMPLATE_METADATA_FAILED',
  READING: 'UPLOADS.READING',
  READ: 'UPLOADS.READ',
  CANCELUPLOAD: 'UPLOADS.CANCELUPLOAD',
  SIGNING: 'UPLOADS.SIGNING',
  SIGNED: 'UPLOADS.SIGNED',
  UPLOADING: 'UPLOADS.UPLOADING',
  UPLOADED: 'UPLOADS.UPLOADED',
  TRANSFORMING: 'UPLOADS.TRANSFORMING',
  COMPLETE: 'UPLOADS.COMPLETE'
};

export const loading = template_key => ({
  type: types.LOADING,
  template_key
});
export const fetchingTemplateMetaData = () => ({
  type: types.FETCHING_TEMPLATE_METADATA
});
export const fetchedTemplateMetaData = (key, templateMetaData) => ({
  type: types.FETCHED_TEMPLATE_METADATA,
  templateMetaData
});
export const fetchTemplateMetaData = () => ({
  type: types.FETCHING_TEMPLATE_METADATA_FAILED
});

export const reading = () => ({
  type: types.READING
});

export const read = file_data => ({
  type: types.READ,
  file_data
});

export const cancelUpload = () => ({
  type: types.CANCELUPLOAD
});

export const signing = () => ({
  type: types.SIGNING
});

export const signed = (upload_url, upload_key) => ({
  type: types.SIGNED,
  upload_url: upload_url,
  upload_key: upload_key
});

export const uploading = () => ({
  type: types.UPLOADING
});

export const uploaded = () => ({
  type: types.UPLOADED
});

export const transforming = () => ({
  type: types.TRANSFORMING
});

export const complete = transformed => ({
  type: types.COMPLETE,
  watermarked_url: transformed['watermarked_url'],
  preview_url: transformed['thumbnail_url'],
  preview_key: transformed['key'],
  template_width: transformed['width'],
  template_height: transformed['height']
});



// WEBPACK FOOTER //
// ./src/store/actions/uploads.js